import React                                                          from 'react';
import PropTypes                                                      from 'prop-types';
import VXPropTypes                                                    from '../../../utils/VXPropTypes';
import VXButton                                                       from "../../SimpleElements/VXButton/VXButton";
import {VXButtonLineConfig}                                           from "../../SimpleElements/VXButton/VXButtonConfig";
import {COLOR_TYPE_DISABLED, COLOR_TYPE_HIGHLIGHT, COLOR_TYPE_MOOD_3} from "../../SimpleElements/VXButton/ButtonHelper";

class Option extends React.Component {
	UNSAFE_componentWillMount() {
		this.onBtnClick = this.onBtnClickHandler.bind(this);
	}

	/**
	 * @param {Event} e
	 */
	onBtnClickHandler(e) {
		if (this.props.isDisabled) {
			e.preventDefault();
			return false;
		}

		return this.props.onChange(this.props.value);
	}

	/**
	 * @return {string}
	 */
	getBtnColor() {
		if (this.props.isSelected) {
			return COLOR_TYPE_HIGHLIGHT;
		}

		if (this.props.isDisabled) {
			return COLOR_TYPE_DISABLED;
		}

		return COLOR_TYPE_MOOD_3;
	}

	render() {
		const label = this.props.label.length > 0 ? this.props.label : this.props.value;

		return this.props.isMobile
			? <VXButton line1={[new VXButtonLineConfig(label)]} onClick={this.onBtnClick} color={this.getBtnColor()} />
			: <option value={this.props.value}>{label}</option>;
	}
}

/**
 * @link https://reactjs.org/docs/typechecking-with-proptypes.html
 */
Option.propTypes = {
	value:      PropTypes.string.isRequired,
	label:      PropTypes.string,
	isMobile:   PropTypes.bool,
	isSelected: PropTypes.bool,
	isDisabled: PropTypes.bool,
	onChange:   VXPropTypes.requiredOnMobile,
};

Option.defaultProps = {
	label:      '',
	isMobile:   false,
	isSelected: false,
	isDisabled: false,
	onChange:   undefined,
};

export default Option;
